import { isObject } from '../guards/index.js';

const detectiOS = () => {
  if (typeof window === "undefined") return false;
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && ("ontouchend" in document || navigator.maxTouchPoints > 1) || /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || "standalone" in navigator && typeof navigator.standalone !== "undefined" && "ontouchstart" in window;
};
const detectAndroid = () => {
  if (typeof window === "undefined") return false;
  return /Android/i.test(navigator.userAgent) || "userAgentData" in navigator && isObject(navigator.userAgentData) && "platform" in navigator.userAgentData && navigator.userAgentData.platform === "Android";
};
const detectMobileBase = (acceptUnknown = false) => {
  if (typeof window === "undefined") return false;
  if (!window.matchMedia("(pointer:coarse) and (max-width: 768px)").matches) {
    return false;
  }
  if (detectiOS()) return "iOS";
  if (detectAndroid()) return "Android";
  if (acceptUnknown) return "Unknown";
  return false;
};
const hasMacOSKbd = () => {
  if (typeof window === "undefined") return false;
  return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
};
const detectMobile = Object.assign(detectMobileBase, {
  iOS: detectiOS,
  Android: detectAndroid
});

export { detectMobile, hasMacOSKbd };
//# sourceMappingURL=index.js.map
